import { z } from 'zod';
import { vaultPostRequest } from '../helpers';

const responseSchema = z.object({ accepted: z.boolean(), uploaderPaused: z.boolean() });

export type IPauseImgUploaderResponse = z.infer<typeof responseSchema>;

export async function pauseImgUploaderApi(): Promise<IPauseImgUploaderResponse> {
  return vaultPostRequest({ path: '/img/pause-uploader', body: {}, schema: responseSchema });
}
